import "./FooterStyles.css";

import React from "react";
import { FaPhone, FaMailBulk, FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-container">
        {/* Left Section */}
        <div className="left">
          <div className="phone">
            <h4>
              <FaPhone size={20} style={{ color: "#fff", marginRight: "1rem" }} />
              1-437-455-4998
            </h4>
          </div>
          <div className="email">
            <h4>
              <FaMailBulk size={20} style={{ color: "#fff", marginRight: "1rem" }} />
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=vortia123@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#fff", textDecoration: "none" }}
              >
                vortia123@gmail.com
              </a>
            </h4>
          </div>
        </div>

        {/* Right Section */}
        <div className="right">
          <h4>© 2025 URIEL VORTIA. All Rights Reserved.</h4>
          <div className="social">
            <a
              href="https://www.linkedin.com/in/urielvortia/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn size={30} style={{ color: "#fff", marginRight: "1rem" }} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
